import React from 'react';

import { Box, Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';

interface MenuLinkItemProps {
  href: string;
  name: string;
  analyticsName: string;
  isActive?: boolean;
  onPress?: () => void;
  showOnTablet?: boolean;
  tabletDisplay?: string;
  isLast?: boolean;
  icon?: React.ReactNode;
}

export const MenuLinkItem: React.FC<MenuLinkItemProps> = ({
  href,
  name,
  analyticsName,
  isActive,
  onPress,
  isLast,
  icon,
}) => {
  return (
    <Text
      as="li"
      className={cn('min-[1024px]:hidden', !isLast && 'border-b border-od-border-primary')}
    >
      <Row
        href={href}
        aria-current={isActive}
        aria-label={name}
        analyticsName={analyticsName}
        onClick={onPress}
        className={cn('items-center gap-2 py-4 pl-6 pr-4', isActive && 'bg-od-bg-hover-primary')}
      >
        {icon && <Box className="h-5 w-5 items-center justify-center">{icon}</Box>}
        <Text as="span" className="text-body-md">
          {name}
        </Text>
      </Row>
    </Text>
  );
};
